const API_BASE_URL = "http://13.125.249.187:8080/api";

export default API_BASE_URL;